import styled, { css } from 'styled-components';

export const bulkCheckboxCss = css`
  .form-check-input {
    width: 1rem;
    height: 1rem;
    margin: 0;
    border: 2px solid #e2e8f0;
    border-radius: 0.125rem;
    cursor: pointer;

    &:checked,
    &:indeterminate {
      border-color: #7367f0;
      background-color: #7367f0;
    }

    &:focus {
      box-shadow: none;
    }
  }
`;

export const BulkActionsBarContainer = styled.div`
  position: fixed;
  z-index: 1000;
  transform: translateX(-50%);
`;

export const BulkActionsBarStyled = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.5rem;
  border-radius: 0.625rem;
  background-color: #272c3b;
  box-shadow: 0 0.5rem 1.5rem rgba(39, 44, 59, 0.24);
  font-family: Poppins, sans-serif;
  font-size: 0.8125rem;

  .bulk-counter {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.375rem 0.5rem 0.375rem 0.75rem;
    border-radius: 0.375rem;
    background-color: rgba(255, 255, 255, 0.1);
    color: #ffffff;
    font-weight: 600;
    white-space: nowrap;

    button {
      display: flex;
      padding: 0;
      border: none;
      background: none;
      color: #ffffff;

      i {
        font-size: 1rem;
      }
    }
  }

  .bulk-select-all {
    padding: 0;
    border: none;
    background: none;
    color: #a8b5ff;
    font-weight: 500;
    text-decoration: underline;
    white-space: nowrap;
  }

  .bulk-all-selected {
    color: #ccd1e0;
    font-weight: 500;
    white-space: nowrap;
  }

  .bulk-divider {
    width: 1px;
    height: 1.5rem;
    background-color: rgba(255, 255, 255, 0.2);
  }

  .bulk-action-wrapper {
    position: relative;
  }

  .bulk-action {
    display: flex;
    align-items: center;
    gap: 0.375rem;
    padding: 0.375rem 0.625rem;
    border: none;
    border-radius: 0.375rem;
    background: none;
    color: #ffffff;
    font-weight: 500;

    i {
      font-size: 1.125rem;
    }

    &:hover,
    &.active {
      background-color: rgba(255, 255, 255, 0.1);
    }

    &:disabled {
      opacity: 0.5;
    }
  }

  .bulk-action-delete {
    color: #ff8787;
  }
`;

export const BulkPopoverStyled = styled.div`
  position: absolute;
  ${({ placement }) =>
    placement === 'bottom' ? 'top: calc(100% + 1rem);' : 'bottom: calc(100% + 1rem);'}
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  width: ${({ width }) => width};
  border: 1px solid #eff2f7;
  border-radius: 0.5rem;
  background-color: #ffffff;
  box-shadow: 0 0.5rem 1.5rem rgba(52, 58, 64, 0.16);
  font-family: Poppins, sans-serif;
  font-size: 0.8125rem;
  text-align: left;

  .popover-header {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    padding: 0.75rem 0.75rem 0.5rem;
    background: none;
    border: none;
  }

  .popover-title {
    margin: 0;
    color: #343a40;
    font-weight: 600;
  }

  .popover-search {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.5rem 0.625rem;
    border: 1px solid #e2e8f0;
    border-radius: 0.375rem;

    &:focus-within {
      border-color: #556ee6;
    }

    i {
      font-size: 1rem;
      color: #a3abb8;
    }

    input {
      width: 100%;
      padding: 0;
      border: none;
      outline: none;
      color: #343a40;

      &::placeholder {
        color: #a3abb8;
      }
    }
  }

  .popover-hint {
    margin: 0;
    color: #6b7380;
    font-size: 0.6875rem;
  }

  .popover-hint-active {
    color: #556ee6;
  }

  .popover-list {
    display: flex;
    flex-direction: column;
    gap: 0.125rem;
    max-height: 12.625rem;
    overflow-y: auto;
    padding: 0 0.25rem 0.25rem;
  }

  .popover-item {
    display: flex;
    align-items: center;
    gap: 0.625rem;
    width: 100%;
    padding: 0.5rem;
    border: none;
    border-radius: 0.375rem;
    background: none;
    color: #343a40;
    font-weight: 500;
    text-align: left;

    &:hover:not(:disabled),
    &.selected {
      background-color: #f1f3fe;
    }

    &.selected {
      font-weight: 600;
    }

    &:disabled {
      color: #a3abb8;
      cursor: default;
    }

    .popover-item-name {
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .popover-item-detail {
      color: #a3abb8;
      font-size: 0.75rem;
      font-weight: 400;
    }

    i {
      font-size: 1rem;
      color: #7367f0;
    }
  }

  .popover-separator {
    height: 1px;
    background-color: #eff2f7;
  }

  .popover-create {
    padding: 0.25rem 0.25rem 0.5rem;

    .popover-item {
      color: #556ee6;
    }

    .popover-item-detail {
      font-size: 0.6875rem;
    }
  }

  .popover-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.5rem;
    padding: 0.625rem 0.75rem;

    .popover-footer-text {
      color: #6b7380;
      font-size: 0.6875rem;
    }

    .btn-cancel {
      padding: 0;
      border: none;
      background: none;
      color: #6b7380;
      font-weight: 500;
    }

    .btn-confirm {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 0.5rem;
      height: 2rem;
      padding: 0.625rem 0.75rem;
      border: none;
      background-color: #7367f0;
      font-size: 0.875rem;
      font-weight: 600;

      &:hover:not(:disabled) {
        background-color: #5e50ee;
      }
    }
  }

  .popover-empty {
    margin: 0;
    padding: 0.5rem 0.75rem;
    color: #6b7380;
  }

  ${bulkCheckboxCss}

  .form-check-input {
    flex-shrink: 0;
  }
`;
